/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

export class OrganisationUsersModel {
  organisationId: string;
  userId: string;
  organisationUserStatus: string;
  createdAt: Date;
  updatedAt: Date;
  roleId: string;
  sessionId: string;
  sessionTimestamp: Date;
  sessionLocked: boolean;
  sonraiSuperUser: boolean;
  runAnalytics: boolean;

  constructor(
    organisationId?: string,
    userId?: string,
    organisationUserStatus?: string,
    createdAt?: Date,
    updatedAt?: Date,
    roleId?: string,
    sessionId?: string,
    sessionTimestamp?: Date,
    sessionLocked?: boolean,
    sonraiSuperUser?: boolean,
    runAnalytics?: boolean
  ) {
    this.organisationId = organisationId;
    this.userId = userId;
    this.organisationUserStatus = organisationUserStatus;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.roleId = roleId;
    this.sessionId = sessionId;
    this.sessionTimestamp = sessionTimestamp;
    this.sessionLocked = sessionLocked;
    this.sonraiSuperUser = sonraiSuperUser;
    this.runAnalytics = runAnalytics;
  }

  toJson(): Object {
    return {
      organisation_id: this.organisationId,
      user_id: this.userId,
      organisation_user_status: this.organisationUserStatus,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
      role_id: this.roleId,
      session_id: this.sessionId,
      session_timestamp: this.sessionTimestamp,
      session_locked: this.sessionLocked,
      sonrai_super_user: this.sonraiSuperUser,
      run_analytics: this.runAnalytics
    };
  }

  fromJson(input: any): OrganisationUsersModel {
    return new OrganisationUsersModel(
      input['organisation_id'],
      input['user_id'],
      input['organisation_user_status'],
      input['created_at'],
      input['updated_at'],
      input['role_id'],
      input['session_id'],
      input['session_timestamp'],
      input['session_locked'],
      input['sonrai_super_user'],
      input['run_analytics']
    );
  }
}
